import { Box, Button, Heading, Link, Stack, Text } from '@chakra-ui/react';
import { useUserContext } from '@providers/useUserContext';
import { useState } from 'react';
import Auth from './Auth';
import UserProfile from './UserProfile';

export function Account() {
  const { isLoggedIn, logout } = useUserContext();
  const [isLoggingOut, setIsLoggingOut] = useState<boolean>(false);

  const primaryColor = mondayMindbody?.customization?.color ?? '#ff7f00';

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
    } finally {
      setIsLoggingOut(false);
    }
  };

  if (isLoggedIn) {
    return (
      <Box className="myAccountContainer">
        <Stack
          spacing={4}
          width="100%"
          margin="1em 0 2em"
          direction={{ base: 'column-reverse', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ base: 'center', md: 'flex-start' }}
        >
          <Heading
            className="accountMainTitle"
            size="lg"
            textTransform="uppercase"
            textAlign={{ base: 'center', md: 'left' }}
          >
            Mon compte
          </Heading>
          <Button
            className="accountLogoutButton"
            variant="contained"
            alignSelf={{ base: 'flex-end', md: 'center' }}
            onClick={handleLogout}
            isLoading={isLoggingOut}
          >
            Se déconnecter
          </Button>
        </Stack>

        <UserProfile />
      </Box>
    );
  }

  return (
    <Stack w="full" p={{ base: '0.5rem', md: '0' }} className="AccountPages">
      <Heading className="accountMainTitle" size="lg" fontSize="5xl" textTransform="uppercase" mt={6} mb={0}>
        Mon compte
      </Heading>
      <Text align="left" mb={6}>
        Utiliser les mêmes identifiants sur vos comptes{' '}
        <Link href="https://dynamo-cycling.com" isExternal textDecoration="underline" color={primaryColor}>
          dynamo
        </Link>
        {', '}
        <Link href="https://punch-boxing.com" isExternal textDecoration="underline" color={primaryColor}>
          Punch
        </Link>{' '}
        {'et, '}
        <Link href="https://riise-studios.com" isExternal textDecoration="underline" color={primaryColor}>
          RIISE
        </Link>{' '}
        : les comptes sont communs.
      </Text>
      <Auth />
    </Stack>
  );
}
